import { h } from "preact";
import QuantityInputRound from "../../global/quantity-input/quantity-input-round";
import StockMessage from "../stock-message";
import ProductOptionVariantContent from "./product-option-variant-content";

export default function ProductOptionVariant({
  variant,
  variantQuantity,
  setVariantQuantity,
  monogram,
  setMonogram,
  smallMonogram = false,
}) {
  const variantOptionTitle =
    variant.selectedOptions[variant.selectedOptions.length - 1].value;
  return (
    <div className="product-option-variant">
      <div className="product-option-variant__header">
        <div className="product-option-variant__title">
          {variantOptionTitle}
        </div>
        <div className="product-option-variant__price">
          {window.formatMoney(
            variant.price.amount,
            false,
            variant.price.currencyCode,
          )}
        </div>
        <QuantityInputRound
          quantity={variantQuantity}
          setQuantity={setVariantQuantity}
          allowZero={true}
        />
      </div>
      <StockMessage variant={variant} monogram={monogram} />
      <ProductOptionVariantContent
        open={variantQuantity > 0}
        variant={variant}
        monogram={monogram}
        setMonogram={setMonogram}
        smallMonogram={smallMonogram}
      />
    </div>
  );
}
